import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const ContactQueryService = {
  actions: {
    fetchAllBlogs ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/blogs',
          method: 'GET'
        })
          .then(resp => {
            const blogs = resp.data.blogs
            commit('api_success')
            resolve(resp)
            return blogs
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    createBlog ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/blog',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    deleteBlog ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/blog/' + id,
          method: 'delete'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    editBlog ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/blog/' + data.get('id'),
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    fetchBlog ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/blog/' + id,
          method: 'GET'
        })
          .then(resp => {
            const blog = resp.data.blog
            commit('api_success')
            resolve(resp)
            return blog
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default ContactQueryService



// WEBPACK FOOTER //
// ./src/services/blogService.js